module.exports = __webpack_public_path__ + "static/media/manabi_01_ja.246e4410.png";